import { useState } from "react";

import { m } from "~/paraglide/messages";
import { camelToSnake } from "~/utils/string.utils";

import { PasswordRules, passwordSchema } from "../helpers";

type PasswordErrors = Partial<Record<PasswordRules, { isValid: boolean; translation: string }>>;

const usePasswordConditions = () => {
  const initialPasswordErrors = Object.values(PasswordRules).reduce<PasswordErrors>(
    (acc, rule) => ({
      ...acc,
      [rule]: { isValid: false, translation: m[`password_rule_${camelToSnake(rule)}`]() },
    }),
    {},
  );

  const [passwordErrors, setPasswordErrors] = useState<PasswordErrors>(initialPasswordErrors);

  const validatePassword = (password: string) => {
    const result = passwordSchema.safeParse(password);

    setPasswordErrors(prevErrors =>
      Object.fromEntries(
        Object.keys(initialPasswordErrors).map(key => [
          key,
          {
            ...prevErrors[key as PasswordRules],
            isValid: result.success ? true : !result.error.issues.some(err => err.message === key),
          },
        ]),
      ),
    );
  };

  return { validatePassword, passwordErrors };
};

export { usePasswordConditions };
export type { PasswordErrors };
